import type { ConfigResponse, GroupId, SpaceSnapshot } from '../types';

const API_BASE = (import.meta.env.VITE_API_BASE || '').replace(/\/$/, '');

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {})
    }
  });
  if (!response.ok) {
    const body = await response.text();
    throw new Error(body || response.statusText);
  }
  return (await response.json()) as T;
}

export async function fetchConfig(): Promise<ConfigResponse> {
  const envSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;
  const cfg = await request<ConfigResponse>('/api/config');
  return { ...cfg, turnstileSiteKey: envSiteKey || cfg.turnstileSiteKey };
}

export async function createSpace(seed: string, groupALabel?: string, groupBLabel?: string): Promise<SpaceSnapshot> {
  return request<SpaceSnapshot>('/api/space', {
    method: 'POST',
    body: JSON.stringify({ seed, groupALabel, groupBLabel })
  });
}

export async function getSpace(spaceId: string): Promise<SpaceSnapshot> {
  return request<SpaceSnapshot>(`/api/space/${spaceId}`);
}

export async function submitVote(args: {
  spaceId: string;
  statementId: string;
  deviceKey: string;
  groupId: GroupId;
  agreement: number;
  confidence: number;
  guessOther: number;
  reactionMs: number;
  turnstileToken?: string;
}): Promise<{ ok: boolean; snapshot: SpaceSnapshot }> {
  return request<{ ok: boolean; snapshot: SpaceSnapshot }>('/api/vote', {
    method: 'POST',
    body: JSON.stringify(args)
  });
}

export async function submitStatement(args: { spaceId: string; text: string; deviceKey: string; turnstileToken?: string }): Promise<unknown> {
  return request('/api/statement', {
    method: 'POST',
    body: JSON.stringify(args)
  });
}

export function websocketUrl(spaceId: string, deviceKey: string): string {
  const base = API_BASE || window.location.origin;
  const url = new URL(`/api/ws/${spaceId}`, base);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.searchParams.set('deviceKey', deviceKey);
  return url.toString();
}
